import { devMode } from "@src/env";
import { useEffect } from "react";

import { Artwork } from "@src/components/Artwork";
import { Background } from "@src/components/Background";
import { CurrentTrackProgress } from "@src/components/CurrentTrackProgress";
import { Debug } from "@src/components/Debug";
import { Footer } from "@src/components/Footer";
import { LoginInfo } from "@src/components/LoginInfo";
import { NextTrack } from "@src/components/NextTrack";
import { OfflineModeIndicator } from "@src/components/OfflineModeIndicator";
import { PlayPause } from "@src/components/PlayPause";
import { PreviousTracks } from "@src/components/PreviousTracks";
import { SocialMedia } from "@src/components/SocialMedia";
import { ValidRender } from "@src/components/ValidRender";
import { Version } from "@src/components/Version";

import { useNativeBridge } from "@src/hooks/useNativeBridge";
import { usePlayer } from "@src/hooks/usePlayer";

import "./style.less";
import type { PlayerProps } from "./types";

export function Player({ raspberry = false }: PlayerProps) {
  const { radio, logout, currentTrack } = usePlayer(raspberry);
  useNativeBridge();

  useEffect(() => {
    if (!raspberry) return;
    function onKeyDown(event: KeyboardEvent) {
      if (event.code === "Numpad5") {
        console.log("[onKeyDown] Refresh page");
        window.location.reload();
      } else if (event.code === "NumpadEnter") {
        console.log("[onKeyDown] Play/Pause");
        document.dispatchEvent(new Event("playPause"));
      }
    }
    window.addEventListener("keydown", onKeyDown);
    return () => {
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [raspberry]);

  if (!radio) {
    return <></>;
  }

  return (
    <ValidRender>
      <div className="Player-page">
        <Background url={currentTrack.artwork_large} raspberry={raspberry} />
        <main>
          <OfflineModeIndicator radio={radio} />
          <Version idRadio={radio.name} />
          <LoginInfo logged_in_as={radio.logged_in_as} logout={logout} />
          {raspberry ? (
            <PlayPause />
          ) : (
            <>
              <SocialMedia />
              <PreviousTracks />
              <div className="artwork-with-progress">
                <Artwork currentTrack={currentTrack} />
                <CurrentTrackProgress />
              </div>
              <NextTrack />
              {/* {isOnlinePlaying && <StreamInfo radio={radio} />} */}
            </>
          )}
          {devMode && <Debug radio={radio} />}
        </main>
        <Footer radio={radio} raspberry={raspberry} />
      </div>
    </ValidRender>
  );
}
